export function HexIcon({ className = "" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12 2 L20.66 7 L20.66 17 L12 22 L3.34 17 L3.34 7 Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default function Logo({ light = false }: { light?: boolean }) {
  return (
    <span className="flex items-center gap-2.5">
      <span className="relative flex h-9 w-9 items-center justify-center">
        <HexIcon className="h-9 w-9 text-honey-400" />
        <HexIcon className="absolute h-4 w-4 text-cream" />
      </span>
      <span
        className={`font-serif text-xl tracking-tight ${
          light ? "text-cream" : "text-charcoal"
        }`}
      >
        Honeycomb
        <span className="text-honey-500">.</span>
      </span>
    </span>
  );
}
